// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604171350/js/" + chunkId + "." + {"44":"c82f10a4","225":"105e7e02","481":"f511f0a1","486":"aea7a78c","770":"515cd4e5"}[chunkId] + ".0.5493121934776424.chunk.js";
};